import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import styles from '@patternfly/react-styles/css/components/ModalBox/modal-box';
export var ModalBox = function ModalBox(_a) {
  var children = _a.children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$variant = _a.variant,
      variant = _a$variant === void 0 ? 'default' : _a$variant,
      ariaLabelledby = _a['aria-labelledby'],
      _a$ariaLabel = _a['aria-label'],
      ariaLabel = _a$ariaLabel === void 0 ? '' : _a$ariaLabel,
      ariaDescribedby = _a['aria-describedby'],
      props = __rest(_a, ["children", "className", "variant", 'aria-labelledby', 'aria-label', 'aria-describedby']);

  return React.createElement("div", Object.assign({}, props, {
    role: "dialog",
    "aria-label": ariaLabel || null,
    "aria-labelledby": ariaLabelledby || null,
    "aria-describedby": ariaDescribedby,
    "aria-modal": "true",
    className: css(styles.modalBox, className, variant === 'large' && styles.modifiers.lg, variant === 'small' && styles.modifiers.sm)
  }), children);
};